export const getBoostedOddsGameData = (standardGameListBoosted) => {
    let orderedRegions = Object.values(standardGameListBoosted).sort((a, b) => {
            return a.regionOrder - b.regionOrder;
        }),
        processed = {};
    const Regions = orderedRegions.reduce((collected, current) => {
        if (!processed.hasOwnProperty(current.regionAlias)) {
            processed[current.regionAlias] = null;
            collected.push({
                [current.regionAlias]: [current],
                regionKey: current.regionAlias
            });
        } else {
            collected.every((region) => {
                region.regionKey === current.regionAlias && region[region.regionKey].push(current);
                return region.regionKey !== current.regionAlias;
            });
        }
        return collected;
    }, []);
    const competitionArray = Regions.map((groupedRegion) => {
        let processed = {};
        return groupedRegion[groupedRegion.regionKey].sort((a, b) => {
            return a.competitionOrder - b.competitionOrder;
        }).reduce((collected, game) => {
            if (!processed.hasOwnProperty(game.competitionName)) {
                processed[game.competitionName] = null;
                collected.push({
                    [game.competitionName]: [game],
                    key: game.competitionName,
                    gameId: game.id,
                    sportAlias: game.alias,
                    start_ts: game.start_ts,
                    regionAlias: game.regionAlias,
                    regionName: game.regionName,
                    name: game.sport && game.sport.name,
                    teams_reversed: game.competitionTeamsReversed
                });
            } else {
                collected.every((groupedCompetition) => {
                    groupedCompetition.key === game.competitionName && groupedCompetition[groupedCompetition.key].push(game);
                    return groupedCompetition.key !== game.competitionName;
                });
            }
            return collected;
        }, []);
    }).reduce((collected, regions) => {
        collected.push(
            ...regions.map((region) => {
                region[region.key] = region[region.key].sort((a, b) => {
                    return a.start_ts - b.start_ts;
                }).map(game => game.id);

                return region;
            })
        );
        return collected;
    }, []);
    return competitionArray;
};

export const StandardGameListBoosted = (standardGameListBoosted) => {
    let sortedData = Object.values(standardGameListBoosted).sort((a, b) => a.order - b.order);
    const bySportAlias = _.groupBy(Object.values(sortedData), 'sportName');
    return Object.keys(bySportAlias).map((key) => {
        return {
            temp: key,
            data: getBoostedOddsGameData(bySportAlias[key])
        };
    });
};